import { useEffect, useState } from "react"
import { OfferItemCard } from "../offer-item-card/offer-item-card"
import CustomCarousel from "../../../../components/UI/caraousel/caraousel"
import { HomePageCarouselType } from "../../constant/hompage.constant"
import { checkIsUserLoggedIn } from "../../../../utils/globalUtilities"

interface LoginOfferCardProps {
    title: string,
    subheading?: string,
    isfilter: Boolean,
    apiresponse: any
    filterchoosed?: any
    filterData?: any
    showReadMore: boolean
    isVideos?: boolean
    numVisible: number
    showprice?:boolean,
    onClickViewAll:any,
    type:string,
    filterType:string,
    selectedTab?:number,
    filterSelectedCirnotType?:Function,
    filterSelectedPracticeTab?:Function,
    filterSelectedLearningTab?:Function,
    filterSelectedResearchTab?:Function
}





export const LoginOfferCards = ({ title, isfilter, apiresponse, filterData, showReadMore, isVideos, numVisible ,showprice, onClickViewAll, type, filterType, filterSelectedPracticeTab, filterSelectedLearningTab, filterSelectedResearchTab }: LoginOfferCardProps) => {
    const [practiceSelectedFilter,setPracticeSelectedFilter]= useState("All");
    const [learningSelectedFilter,setLearningSelectedFilter]= useState("All");
    const [researchSelectedFilter,setResearchSelectedFilter]= useState("All");
    const [activeIndex, setActiveIndex] = useState(0);
    useEffect(() => {
        let interval: NodeJS.Timeout;
        if(apiresponse?.length){

        const startAutoScroll = () => {
          interval = setInterval(() => {            
            // setActiveIndex((prevIndex) => (prevIndex + 1) % apiresponse.length);
          }, 300);
        };
      
        startAutoScroll();
    }
        return () => clearInterval(interval);
      }, [apiresponse]);  
    const itemsWithIndex = apiresponse?.map((item: any, idx: number) => ({
        ...item,
        customIndex: idx + 1,
    }));
    return (
        <>
            <div className={`recent_case_laws `}>
                <h3 className={`case_law_head ${title.toLowerCase()}-text-1`}>{title}</h3>
                {
                isfilter && apiresponse && filterData?.researchTabList && <ul className="case_law_options text_capitalize_1">
                    {filterData && filterData?.researchTabList?.map((list: any, indexcourt:number) => {
                        return <li key={`ResearchFilter${indexcourt}`} className={` ${list?.name == researchSelectedFilter ? 'active_caselaw_option' : ''} `} onClick={() => {
                            filterSelectedResearchTab(list?.id, list?.name)
                            setResearchSelectedFilter(list?.name)
                        }
                        }>{list?.name}</li>
                    })}
                </ul>
                }
                {
                isfilter && apiresponse && filterData?.practiceTabList && <ul className="case_law_options text_capitalize_1">
                    {filterData && filterData?.practiceTabList?.map((list: any, indexcourt:number) => {
                        return <li key={`PracticeFilter${indexcourt}`} className={` ${list?.name == practiceSelectedFilter ? 'active_caselaw_option' : ''} `} onClick={() => {
                            list.name=='All' && filterSelectedPracticeTab(list?.id, 'All');
                            list.name!='All' && filterSelectedPracticeTab(list?.id, list?.id[0]);
                            setPracticeSelectedFilter(list?.name)
                        }
                        }>{list?.name}</li>
                    })}
                </ul>
                }
                {
                isfilter && apiresponse && filterData?.learningTabList && <ul className="case_law_options text_capitalize_1">
                    {filterData && filterData?.learningTabList?.map((list: any, indexcourt:number) => {
                        return <li key={`PracticeFilter${indexcourt}`} className={` ${list?.name == learningSelectedFilter ? 'active_caselaw_option' : ''} `} onClick={() => {
                            filterSelectedLearningTab(list?.id, list?.name);
                            setLearningSelectedFilter(list?.name)
                        }
                        }>{list?.name}</li>
                    })}
                </ul>
                }
                <div className="laws_lists">
                    {apiresponse && apiresponse?.length > 0 && <div className="carousel-ui-1 learning_details cards-4-desktop">
                        <CustomCarousel numVisible={numVisible} mobNumVisible={1}
                            carouselItems={itemsWithIndex} tabNumVisible={3}
                            itemTemplate={(list: any) => <OfferItemCard itemsList={list}  customIndex={list.customIndex} showReadMore={showReadMore} isVideos={isVideos} showprice={showprice} />
                        } showIndicators={false}
                            showNavigators={false} 
                        />
                    </div>}
                    <div className="view_btn">
                           <a className="button-primary active cursor-pointer" target={checkIsUserLoggedIn() ? "_blank" : "_self"} href={onClickViewAll(type, filterType)}>View All <svg className="stroke" width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.93 6.17993L21 12.2499L14.93 18.3199" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" /><path d="M4 12.25H20.83" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" /></svg></a>
                    </div>
                </div>
            </div>

        </>
    )


}